import React from 'react';
import * as R from 'ramda';
// components
import { TextComponent } from '../../../components/text';
// helpers/constants
import * as GC from '../../../constants';
// feature geo-fencing-zone
import { getZoneUsageLabel, getZoneUsageOptions } from './field-settings';
// ui
import { Flex } from '../../../ui';
//////////////////////////////////////////////////

export const columnSettings = {
  [GC.FIELD_NAME]: {
    width: 400,
    name: 'titles:name',
    customComponent: ({ data: { name, color } }) => (
      <Flex>
        {color && <Flex mr='5px' width={20} height={20} flexShrink={0} background={color} borderRadius='4px' />}
        <TextComponent title={name} withEllipsis={true} maxWidth='calc(100% - 20px)'>
          {name}
        </TextComponent>
      </Flex>
    ),
  },
  [GC.FIELD_BRANCH_DOT_BRANCH_NAME]: {
    width: 180,
    name: 'titles:branch',
  },
  [GC.FIELD_CREATED_DATE]: {
    type: 'date',
    filter: { type: 'date' },
    name: 'titles:created-date',
  },
  [GC.FIELD_CREATED_BY]: {
    width: 160,
    name: 'titles:created-by',
  },
  [GC.FIELD_LAST_MODIFIED_DATE]: {
    type: 'date',
    filter: { type: 'date' },
    name: 'titles:last-modified-date',
  },
  [GC.FIELD_LAST_MODIFIED_BY]: {
    width: 160,
    name: 'titles:last-modified-by',
  },
};

export const report = {
  fields: R.of(Array, { sequence: 1, name: GC.FIELD_NAME }),
};

const zoneUsageColumnSettings = () => ({
  width: 220,
  name: 'titles:zone-usage',
  filter: {
    type: 'selectMultiple',
    options: getZoneUsageOptions(),
    placeholder: { text: 'Choose', key: 'titles:choose' },
  },
  customComponent: ({ data }) => getZoneUsageLabel(R.prop(GC.FIELD_GEO_FENCING_ZONE_ZONE_USAGE, data)),
});

export const getReportColumnSettings = () =>
  R.assoc(
    GC.FIELD_GEO_FENCING_ZONE_ZONE_USAGE,
    zoneUsageColumnSettings(),
    columnSettings,
  );

export const geoFencingZoneDetailsColumnSettings = {
  [GC.FIELD_GEO_FENCING_ZONE_CITIES]: {
    width: 500,
    name: 'titles:cities',
    customComponent: ({ data }) =>
      R.join(', ', R.prop(GC.FIELD_GEO_FENCING_ZONE_CITIES, data)),
  },
  [GC.FIELD_GEO_FENCING_ZONE_STATES]: {
    width: 500,
    type: 'state',
    name: 'titles:states',
  },
  [GC.FIELD_GEO_FENCING_ZONE_COUNTRIES]: {
    width: 500,
    name: 'titles:countries',
    customComponent: ({ data }) =>
      R.join(', ', R.prop(GC.FIELD_GEO_FENCING_ZONE_COUNTRIES, data)),
  },
  [GC.FIELD_ZIP_PREFIX]: {
    width: 150,
    name: 'titles:zip-prefix',
  },
  [GC.FIELD_GEO_FENCING_ZONE_ZIP_CODES]: {
    width: 300,
    name: 'titles:zip-codes',
    customComponent: ({ data }) =>
      R.join(', ', R.prop(GC.FIELD_GEO_FENCING_ZONE_ZIP_CODES, data)),
  },
  [GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_TO]: {
    width: 100,
    name: 'titles:zip-to',
  },
  [GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_FROM]: {
    width: 100,
    name: 'titles:zip-from',
  },
};

const commonReportFields = [
  { sequence: 2, name: GC.FIELD_GEO_FENCING_ZONE_STATES },
  { sequence: 3, name: GC.FIELD_GEO_FENCING_ZONE_COUNTRIES },
  { sequence: 4, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_CODES },
  { sequence: 6, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_TO },
  { sequence: 5, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_FROM },
];

const reportDetailsFields = [
  { sequence: 2, name: GC.FIELD_GEO_FENCING_ZONE_STATES },
  { sequence: 3, name: GC.FIELD_GEO_FENCING_ZONE_COUNTRIES },
  { sequence: 4, name: GC.FIELD_ZIP_PREFIX },
  { sequence: 5, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_CODES },
  { sequence: 7, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_TO },
  { sequence: 6, name: GC.FIELD_GEO_FENCING_ZONE_ZIP_RANGE_FROM },
];

export const ratingGeoFencingZoneDetailsReport = {
  fields: R.prepend({ sequence: 1, name: GC.FIELD_GEO_FENCING_ZONE_CITIES }, commonReportFields),
};

export const reportGeoFencingZoneDetailsReport = {
  fields: reportDetailsFields,
};
